module.exports = __webpack_public_path__ + "static/img/sustain_comp.1f6622f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/sustain_comp.png
// module id = jmAf
// module chunks = 12